export default __webpack_public_path__ + "static/media/IMG_5370.d74543c1.WEBP";